import React from "react";
import { Card, Box } from "@bca/ui-library";
import styled from "styled-components";
import { layout } from "styled-system";

import BidNowContent, { BidNowContentProps } from "./BidNowContent";

const StyledCard = styled(Card)`
  ${layout}
`;

const BidNowCard: React.FunctionComponent<BidNowContentProps> = (props) => {
  return (
    <Box
      width={{ mobile: "100%", tablet: "100%", desktop: "50%" }}
      css={`
        @media screen and (min-width: 769px) and (max-width: 950px) {
          width: 70%;
        }
      `}
    >
      <StyledCard
        width="100%"
        height="auto"
        paddingX={28}
        paddingY={28}
        marginX={0}
        marginY={[3, 7, 0]}
      >
        <BidNowContent {...props} />
      </StyledCard>
    </Box>
  );
};

export default BidNowCard;
